import fr from 'facet-rest';
import BaseOverride from 'Overrides/OnboardingStep/BaseOverride';
import {
  IconPicklist,
} from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/GoalSelection/components/IconPicklist/IconPicklist';
import Text from 'Components/ComponentLibrary/Atoms/Text';
import { overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverrideLite';
import { FDBodyText } from '@facet-wealth/design';
import LabellessTextField from 'Components/ComponentLibrary/Components/Uncategorized/LabellessTextField';

const GoalSelectionOverride = fr
  .metaOverride({ base: BaseOverride })
  .typeOverride('multipicklist', {
    _component: () => IconPicklist,
    _customProps: {
      multiSelect: true,
    },
  })
  .nameOverride('title', {
    hidden: false, // This is here because BaseOverride sets it to hidden: true for title
    _component: () => Text,
    _customProps: {
      variant: 'h1',
      weight: 'medium',
      align: 'center',
    },
  }, overrideReadOnly)
  .nameOverride('subtitle', {
    _component: () => FDBodyText,
    _customProps: {
      color: 'textDisabled',
      align: 'center',
    },
  }, overrideReadOnly)
  .nameOverride('name', {
    _component: () => LabellessTextField,
    showHelperTextOnInlineSubmit: false,
    placeholder: 'Name your goal...',
  }, overrideReadOnly);

export default GoalSelectionOverride;
